import React from "react";
import { TextField } from "@mui/material";

type CustomTextAreaType = {
    id: string,
    label: string,
    textValue: string,
    setTextValue: (value: string) => void,
    required?: boolean,
    disabled?: boolean
}

const CustomTextArea = (props: CustomTextAreaType) => {
    return (
        <TextField
            id={props.id}
            label={props.label}
            multiline
            rows={4}
            margin="normal"
            fullWidth
            value={props.textValue}
            onChange={(e) => props.setTextValue(e.target.value)}
            required={props.required}
            disabled={props.disabled}
        />
    )
}

export default CustomTextArea;